<template>
    <div class="news-page">
        <div class="container">
            <div class="page-title" v-if="setup != null">
                <h1>{{ setup.page_titles.news_title }}</h1>
            </div>
            <div class="news-page-columns">
                <div class="col-left">
                    <div class="year-filter-select">
                        <div class="drop-filter-name" :class="{'open' : open_filter}">
                            <a href="#" @click.prevent="open_filter = !open_filter">{{ activeYear }}</a>
                            <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu" :class="{'open' : open_filter}">
                            <simplebar data-simplebar-auto-hide="false" class="dropdown-scroll-container">
                                <div class="drop-checkbox-container">
                                    <div class="item-R" :class="{'active' : activeYear == 'Все года', 'active' : activeYear == 'Барлық жылдар'}" @click="filterNewsItems('all')">
                                        <span v-if="globalLang != 'kz/'">Все года</span>
                                        <span v-else>Барлық жылдар</span>
                                    </div>
                                    <div class="item-R" v-for="item in yearList" :class="{'active' : activeYear == item}" @click="filterNewsItems(item)">
                                        <span>{{ item }}</span>
                                    </div>
                                </div>
                            </simplebar>
                        </div>
                    </div>
                    <button class="btn-call-us" v-if="!isMobileChecker" @click="openContactsFormModal('call', 'news-page', 'Левая колонка')">
                        <span v-if="globalLang == ''">Связаться с нами</span>
                        <span v-if="globalLang == 'kz/'">Кері байланыс</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </button>
                </div>
                <div class="col-right">
                    <newsItems :newsItems="newsItems" class="news-items-mainpage" v-if="newsItems != null && newsItems.length > 0"></newsItems>
                    <strong class="news-notfound-msg" v-else>В заданном диапазоне ноовостей не найдено</strong>
                    <button class="btn-pagination" v-if="newsItems != null && newsPaginCurPage !== newsPaginTotalPage" @click="paginationNews">
                        <span>Загрузить еще</span>
                        <svgIcon name="load-more" class="icon-load-more"/>
                    </button>
                </div>
            </div>
        </div>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import newsItems from '@/components/news-page/news-item.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import simplebar from 'simplebar-vue';
    import 'simplebar-vue/dist/simplebar.min.css';
    import formPage from '@/components/forms/form-page.vue'

    export default {
        name: 'news--page',
        components: {
            newsItems,
            simplebar,
            svgIcon,
            formPage,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Новости',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                open_filter: false,
                yearList: ['2024', '2023', '2022', '2021', '2020', '2019', '2018'],
                activeYear: 'Все года',
                currentDate: null,
                currentDateDefault: 'start_date=2018-01-01&end_date=2030-12-31',
                currentFilterDate: null,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            newsItems: 'loadNewsItems',
            newsPaginTotalPage: 'loadNewsPaginTotalPage',
            newsPaginCurPage: 'loadNewsPaginCurPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            filterNewsItems(param) {
                this.open_filter = false;
                // start_date=2020-01-01
                this.currentDate = 'start_date=' + param +'-01-01' + '&end_date=' + param +'-12-31';
                // var currentDate = '"start_date":"'+ param +'-01-01", "end_date": "'+ param +'-12-31"'
                if (param != 'all') {
                    this.activeYear = param;
                    this.$store.dispatch('getNewsItemsByFilterData', this.currentDate)
                } else {
                    if (this.globalLang != 'kz/') {
                        this.activeYear = 'Все года';
                    } else {
                        this.activeYear = 'Барлық жылдар';
                    }
                    this.$store.dispatch('getNewsItemsByFilterData', this.currentDateDefault)
                }
            },
            paginationNews() {
                var urlPay;
                if (this.activeYear != 'Все года' && this.activeYear != 'Барлық жылдар') {
                    urlPay = 'page=' + Math.floor(this.newsPaginCurPage + 1) + '&' + this.currentDate;
                    this.$store.dispatch('getNewsItemsPgination', urlPay);
                } else {
                    urlPay = 'page=' + Math.floor(this.newsPaginCurPage + 1);
                    this.$store.dispatch('getNewsItemsPgination', urlPay);
                }
            },
            openContactsFormModal(param, page, block) {
                this.$store.commit('formGlobalParam_set', param);
                this.$store.commit('formGlobalDataModal_set', {'page' : page, 'block' : block});
                this.$store.commit('formModalContainerOpen');
            },
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.newsItems != null) {
                next();
            } else {
                store.dispatch('getNewsItemsDefault').then((response) => {
                    if (response) {
                        next();
                    } else {
                        next(false);
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'news';
            
        },
        created () {
        },
        mounted() {
            if (this.globalLang == 'kz/') {
                this.activeYear = 'Барлық жылдар';
            } else {
                this.activeYear = 'Все года';
            }
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/news-page/news-page.scss';
    @import '@/styles/components/news-page/respond/news-page-respond.scss';
</style>